package hk.com.vr360_demo2.webapp.core.net

import hk.com.vr360_demo2.webapp.core.net.common.*
import io.ktor.client.HttpClient
import io.ktor.client.request.post
import io.ktor.client.request.*
import io.ktor.http.ContentType
import io.ktor.http.contentType
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.builtins.serializer
import kotlinx.serialization.json.Json

// 2. PublicApi 接口擴展
interface PublicApi {
    suspend fun loadVr360ViewData(
        id: String,
        uid: String? = null,
        token: String? = null,
    ): ApiResponse<ResponseInfo<PanoramaDataJsonResult>>
    suspend fun savePanoramaData(data: PanoramaEditData, token: String): ApiResponse<ResponseInfo<SaveResult>>
    suspend fun loadVr360EditData(id: String, token: String): ApiResponse<ResponseInfo<PanoramaDataJsonResult>>
}

class KtorPublicApi(private val client: HttpClient) : PublicApi {
    companion object {
        val BASE_URL = AppConfig.apiUrl         //http://www.super-pp.cn
        const val PATH = "/vr/360"
    }

    override suspend fun loadVr360ViewData(
        id: String,
        uid: String?,
        token: String?,
    ): ApiResponse<ResponseInfo<PanoramaDataJsonResult>> {
        return httpRequest<ResponseInfo<PanoramaDataJsonResult>>(client) {
            val url = "$BASE_URL$PATH/view"
            get(url) {
                url {
                    parameters.append("id", id)
                    if (uid != null) parameters.append("uid", uid)
                }
                if (!token.isNullOrBlank()) {
                    headers {
                        append("token", token)
                    }
                }
            }
        }
    }

//    override suspend fun savePanoramaData(
//        data: PanoramaEditData,
//        token: String
//    ): ApiResponse<ResponseInfo<SaveResult>> {
//        return httpRequest<ResponseInfo<SaveResult>>(client) {
//            val url = "$BASE_URL$PATH/edit/save"
//            post(url) {
//                contentType(ContentType.Application.Json)
//                setBody(Json.encodeToString(ListSerializer(SaveSceneInfo.serializer()), data.scenes))
//                headers {
//                    append("token", token)
//                }
//            }
//        }
//    }
    override suspend fun savePanoramaData(
        data: PanoramaEditData,
        token: String
    ): ApiResponse<ResponseInfo<SaveResult>> {
        return httpRequest<ResponseInfo<SaveResult>>(client) {
            val url = "$BASE_URL$PATH/edit/save"
            post(url) {
                contentType(ContentType.Application.FormUrlEncoded)
                url {
                    parameters.append(
                        "vrModelInfoJson",
                        Json.encodeToString(ListSerializer(SaveSceneInfo.serializer()), data.scenes)
                    )                }
                headers {
                    append("token", token)
                }
            }
        }
    }

    override suspend fun loadVr360EditData(
        id: String,
        token: String
    ): ApiResponse<ResponseInfo<PanoramaDataJsonResult>> {
        return httpRequest<ResponseInfo<PanoramaDataJsonResult>>(client) {
            val url = "$BASE_URL$PATH/edit"
            get(url) {
                url {
                    parameters.append("id", id)
                }
                headers {
                    append("token", token)
                }
            }
        }
    }
}